import { render, staticRenderFns } from "./BanckDoc_Detail_learner.vue?vue&type=template&id=0c178696&"
import script from "./BanckDoc_Detail_learner.vue?vue&type=script&lang=js&"
export * from "./BanckDoc_Detail_learner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports